import { render, staticRenderFns } from "./EditBannerPhotoComponent.vue?vue&type=template&id=6142d0fe&scoped=true"
import script from "./EditBannerPhotoComponent.vue?vue&type=script&lang=js"
export * from "./EditBannerPhotoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6142d0fe",
  null
  
)

export default component.exports